import app from '@/app.js';
import { install } from 'vue3-recaptcha-v2';

app.use(install, { sitekey: import.meta.env.VUE_APP_RECAPTCHA_KEY });
